// Auto-generated by scan_recipe_images.js
// Run: node scripts/scan_recipe_images.js

export interface RecipeImageWeight {
  weight_min: number;
  weight_max: number;
  weights?: number[];
  [pieceType: string]: number[] | number | undefined;
}

export interface RecipeImagePortionData {
  [portionType: string]: RecipeImageWeight;
}

export interface RecipeImageData {
  recipe: string;
  portionTypes: RecipeImagePortionData;
}

export interface FishRecipeImageData {
  serialNumber: number;
  fishId: string;
  recipes: RecipeImageData[];
}

export const recipeImageData: FishRecipeImageData[] = [
  {
    "serialNumber": 1,
    "fishId": "bheda",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              16,
              36,
              41,
              55
            ],
            "weight_min": 6,
            "weight_max": 65
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              11,
              26,
              36
            ],
            "weight_min": 4,
            "weight_max": 43
          }
        }
      }
    ]
  },
  {
    "serialNumber": 2,
    "fishId": "katla",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              32,
              49
            ],
            "head": [
              82,
              154
            ],
            "middle": [
              47
            ],
            "tail": [
              47,
              67
            ],
            "ventral": [
              31
            ],
            "weight_min": 2,
            "weight_max": 185
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              33,
              57
            ],
            "head": [
              63
            ],
            "middle": [
              42,
              55,
              67
            ],
            "tail": [
              46
            ],
            "ventral": [
              28
            ],
            "weight_min": 18,
            "weight_max": 77
          }
        }
      }
    ]
  },
  {
    "serialNumber": 3,
    "fishId": "carpio",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              37,
              51
            ],
            "head": [
              121
            ],
            "tail": [
              88
            ],
            "ventral": [
              18,
              24,
              31
            ],
            "weight_min": 2,
            "weight_max": 147
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              33,
              51
            ],
            "head": [
              116
            ],
            "tail": [
              54
            ],
            "ventral": [
              7,
              19,
              28
            ],
            "weight_min": 2,
            "weight_max": 144
          }
        }
      }
    ]
  },
  {
    "serialNumber": 4,
    "fishId": "koi",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              19,
              24
            ],
            "tail": [
              8,
              11
            ],
            "weight_min": 4,
            "weight_max": 28
          },
          "whole": {
            "weights": [
              20
            ],
            "weight_min": 12,
            "weight_max": 36
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              16
            ],
            "tail": [
              10
            ],
            "weight_min": 8,
            "weight_max": 18
          },
          "whole": {
            "weights": [
              18
            ],
            "weight_min": 10,
            "weight_max": 33
          }
        }
      }
    ]
  },
  {
    "serialNumber": 5,
    "fishId": "mola",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              23,
              40,
              71
            ],
            "weight_min": 11,
            "weight_max": 83
          }
        }
      }
    ]
  },
  {
    "serialNumber": 6,
    "fishId": "mrigel",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              101,
              118
            ],
            "middle": [
              41,
              52
            ],
            "tail": [
              77
            ],
            "weight_min": 21,
            "weight_max": 138
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              66
            ],
            "middle": [
              41,
              49,
              64
            ],
            "tail": [
              60,
              73
            ],
            "weight_min": 33,
            "weight_max": 81
          }
        }
      }
    ]
  },
  {
    "serialNumber": 7,
    "fishId": "pangas",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              32,
              41,
              64
            ],
            "head": [
              83
            ],
            "middle": [
              30,
              72
            ],
            "tail": [
              148
            ],
            "ventral": [
              23,
              30,
              61
            ],
            "weight_min": 2,
            "weight_max": 180
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              29,
              31
            ],
            "middle": [
              39
            ],
            "tail": [
              65
            ],
            "ventral": [
              13,
              20,
              34
            ],
            "weight_min": 2,
            "weight_max": 78
          }
        }
      }
    ]
  },
  {
    "serialNumber": 8,
    "fishId": "pora_bele",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              37,
              54,
              80,
              94
            ],
            "tail": [
              29,
              39,
              55
            ],
            "weight_min": 12,
            "weight_max": 111
          },
          "whole": {
            "weights": [
              32,
              50
            ],
            "weight_min": 27,
            "weight_max": 55
          }
        }
      }
    ]
  },
  {
    "serialNumber": 9,
    "fishId": "puti",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              23,
              39
            ],
            "weight_min": 19,
            "weight_max": 43
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "portion": {
            "weights": [
              9,
              22,
              33
            ],
            "weight_min": 3,
            "weight_max": 39
          }
        }
      }
    ]
  },
  {
    "serialNumber": 10,
    "fishId": "rui",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              67,
              98
            ],
            "head": [
              162
            ],
            "middle": [
              38,
              53,
              87
            ],
            "tail": [
              124
            ],
            "ventral": [
              42,
              64
            ],
            "weight_min": 7,
            "weight_max": 193
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              33
            ],
            "head": [
              82
            ],
            "middle": [
              33,
              41,
              71
            ],
            "tail": [
              73
            ],
            "ventral": [
              34
            ],
            "weight_min": 20,
            "weight_max": 95
          }
        }
      }
    ]
  },
  {
    "serialNumber": 11,
    "fishId": "shing",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              8
            ],
            "middle": [
              8
            ],
            "tail": [
              6
            ],
            "weight_min": 5,
            "weight_max": 9
          },
          "portion": {
            "weights": [
              21,
              42,
              70
            ],
            "weight_min": 8,
            "weight_max": 83
          }
        }
      }
    ]
  },
  {
    "serialNumber": 12,
    "fishId": "shoal",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              49,
              60
            ],
            "middle": [
              25,
              34,
              53,
              66
            ],
            "tail": [
              15,
              37
            ],
            "weight_min": 2,
            "weight_max": 79
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              43,
              107
            ],
            "middle": [
              14,
              20,
              27,
              49
            ],
            "tail": [
              18
            ],
            "weight_min": 2,
            "weight_max": 131
          }
        }
      }
    ]
  },
  {
    "serialNumber": 13,
    "fishId": "silver_carp",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              32,
              43
            ],
            "head": [
              68,
              136
            ],
            "middle": [
              27,
              40
            ],
            "tail": [
              50
            ],
            "weight_min": 2,
            "weight_max": 164
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              22,
              29
            ],
            "head": [
              39,
              59
            ],
            "middle": [
              24,
              25
            ],
            "tail": [
              34
            ],
            "ventral": [
              8
            ],
            "weight_min": 2,
            "weight_max": 72
          }
        }
      }
    ]
  },
  {
    "serialNumber": 14,
    "fishId": "taki",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              15,
              20,
              28
            ],
            "middle": [
              10,
              15
            ],
            "tail": [
              7,
              17
            ],
            "weight_min": 2,
            "weight_max": 34
          },
          "whole": {
            "weights": [
              17
            ],
            "weight_min": 10,
            "weight_max": 31
          }
        }
      }
    ]
  },
  {
    "serialNumber": 15,
    "fishId": "tengra",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              14,
              29,
              46
            ],
            "weight_min": 6,
            "weight_max": 54
          },
          "whole": {
            "weights": [
              5,
              8
            ],
            "weight_min": 4,
            "weight_max": 9
          }
        }
      }
    ]
  },
  {
    "serialNumber": 16,
    "fishId": "sarpunti",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              50,
              81
            ],
            "middle": [
              28,
              48
            ],
            "tail": [
              43,
              60
            ],
            "weight_min": 14,
            "weight_max": 95
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              33,
              48
            ],
            "middle": [
              20,
              30,
              40
            ],
            "tail": [
              27,
              39
            ],
            "weight_min": 13,
            "weight_max": 55
          }
        }
      }
    ]
  },
  {
    "serialNumber": 17,
    "fishId": "tilapia",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              65,
              78,
              106
            ],
            "middle": [
              30,
              36
            ],
            "tail": [
              51,
              63,              
              84
            ],
            "weight_min": 11,
            "weight_max": 125
          },
          "whole": {
            "weights": [
              67
            ],
            "weight_min": 50,
            "weight_max": 101
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              41,
              64,
              87
            ],
            "middle": [
              38,
              49
            ],
            "tail": [
              45
            ],
            "weight_min": 25,
            "weight_max": 100
          },
          "whole": {
            "weights": [
              66
            ],
            "weight_min": 49,
            "weight_max": 99
          }
        }
      }
    ]
  },
  {
    "serialNumber": 18,
    "fishId": "bhangan",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              51,
              53
            ],
            "head": [
              68,
              150
            ],
            "middle": [
              51,
              53,
              63
            ],
            "tail": [
              63
            ],
            "ventral": [
              29
            ],
            "weight_min": 2,
            "weight_max": 181
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              82
            ],
            "middle": [
              27,
              31,
              38,
              44,
              58,
              67
            ],
            "tail": [
              37,
              82
            ],
            "ventral": [
              19
            ],
            "weight_min": 3,
            "weight_max": 98
          }
        }
      }
    ]
  },
  {
    "serialNumber": 19,
    "fishId": "bhola",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              24,
              33,
              65
            ],
            "middle": [
              22,
              32,
              50
            ],
            "tail": [
              20,
              31
            ],
            "weight_min": 8,
            "weight_max": 77
          },
          "whole": {
            "weights": [
              56,
              64
            ],
            "weight_min": 54,
            "weight_max": 66
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              20,
              34,
              45,
              58
            ],
            "middle": [
              27
            ],
            "tail": [
              14,
              21
            ],
            "weight_min": 3,
            "weight_max": 69
          },
          "whole": {
            "weights": [
              32,
              39
            ],
            "weight_min": 30,
            "weight_max": 41
          }
        }
      }
    ]
  },
  {
    "serialNumber": 20,
    "fishId": "caine_magur",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              15,
              19,
              23
            ],
            "middle": [
              8,
              11
            ],
            "tail": [
              11
            ],
            "weight_min": 4,
            "weight_max": 27
          }
        }
      }
    ]
  },
  {
    "serialNumber": 21,
    "fishId": "datina",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              58,
              70
            ],
            "tail": [
              42,
              63
            ],
            "weight_min": 35,
            "weight_max": 77
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              43,
              69
            ],
            "middle": [
              39
            ],
            "tail": [
              45,
              60
            ],
            "weight_min": 31,
            "weight_max": 77
          },
          "whole": {
            "weights": [
              46
            ],
            "weight_min": 32,
            "weight_max": 74
          }
        }
      }
    ]
  },
  {
    "serialNumber": 22,
    "fishId": "fesa",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              13,
              18
            ],
            "weight_min": 11,
            "weight_max": 20
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              7,
              11
            ],
            "weight_min": 6,
            "weight_max": 12
          }
        }
      }
    ]
  },
  {
    "serialNumber": 23,
    "fishId": "gaberdana",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              20,
              36,
              68
            ],
            "weight_min": 8,
            "weight_max": 80
          }
        }
      }
    ]
  },
  {
    "serialNumber": 24,
    "fishId": "ilish",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              30
            ],
            "head": [
              69,
              88
            ],
            "middle": [
              22,
              35
            ],
            "tail": [
              34,
              48
            ],
            "ventral": [
              38
            ],
            "weight_min": 5,
            "weight_max": 105
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              23
            ],
            "head": [
              42
            ],
            "middle": [
              13,
              22,
              32
            ],
            "tail": [
              30
            ],
            "ventral": [
              21
            ],
            "weight_min": 5,
            "weight_max": 50
          }
        }
      }
    ]
  },
  {
    "serialNumber": 25,
    "fishId": "katkoi",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              33,
              57
            ],
            "tail": [
              29
            ],
            "weight_min": 22,
            "weight_max": 64
          },
          "whole": {
            "weights": [
              42,
              50,
              66
            ],
            "weight_min": 36,
            "weight_max": 72
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              26
            ],
            "tail": [
              20,
              31
            ],
            "weight_min": 17,
            "weight_max": 34
          },
          "whole": {
            "weights": [
              22,
              33
            ],
            "weight_min": 19,
            "weight_max": 36
          }
        }
      }
    ]
  },
  {
    "serialNumber": 26,
    "fishId": "khoira",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              29,
              34,
              47
            ],
            "weight_min": 24,
            "weight_max": 52
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              22,
              28
            ],
            "weight_min": 20,
            "weight_max": 30
          }
        }
      }
    ]
  },
  {
    "serialNumber": 27,
    "fishId": "khorshula",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "head": [
              36,
              43
            ],
            "middle": [
              33
            ],
            "tail": [
              29,
              35,
              65
            ],
            "weight_min": 20,
            "weight_max": 74
          },
          "whole": {
            "weights": [
              16,
              20
            ],
            "weight_min": 15,
            "weight_max": 21
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "head": [
              19
            ],
            "middle": [
              22
            ],
            "tail": [
              48
            ],
            "weight_min": 11,
            "weight_max": 56
          },
          "whole": {
            "weights": [
              5,
              11
            ],
            "weight_min": 3,
            "weight_max": 13
          }
        }
      }
    ]
  },
  {
    "serialNumber": 28,
    "fishId": "nona_tengra",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              6,
              11,
              21
            ],
            "weight_min": 2,
            "weight_max": 25
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              2,
              8,
              14
            ],
            "weight_min": 2,
            "weight_max": 17
          }
        }
      }
    ]
  },
  {
    "serialNumber": 29,
    "fishId": "parsey",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              8,
              17
            ],
            "weight_min": 5,
            "weight_max": 20
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              8
            ],
            "weight_min": 4,
            "weight_max": 16
          }
        }
      }
    ]
  },
  {
    "serialNumber": 30,
    "fishId": "payra",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              58,
              76,
              84,
              105
            ],
            "weight_min": 46,
            "weight_max": 117
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              38,
              50,
              58,
              101
            ],
            "weight_min": 22,
            "weight_max": 117
          }
        }
      }
    ]
  },
  {
    "serialNumber": 31,
    "fishId": "shilong",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              6,
              10
            ],
            "weight_min": 5,
            "weight_max": 11
          }
        }
      }
    ]
  },
  {
    "serialNumber": 32,
    "fishId": "taposhi",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              8,
              18
            ],
            "weight_min": 5,
            "weight_max": 21
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              5,
              12
            ],
            "weight_min": 3,
            "weight_max": 14
          }
        }
      }
    ]
  },
  {
    "serialNumber": 33,
    "fishId": "koral",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              34,
              58
            ],
            "head": [
              64
            ],
            "middle": [
              33,
              103
            ],
            "tail": [
              31,
              124
            ],
            "ventral": [
              32
            ],
            "weight_min": 7,
            "weight_max": 148
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "piece": {
            "dorsal": [
              26,
              47,
              53
            ],
            "head": [
              49
            ],
            "middle": [
              27,
              30
            ],
            "tail": [
              25
            ],
            "ventral": [
              23
            ],
            "weight_min": 15,
            "weight_max": 61
          }
        }
      }
    ]
  },
  {
    "serialNumber": 34,
    "fishId": "bagda",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              6,
              10,
              11,
              15
            ],
            "weight_min": 3,
            "weight_max": 18
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              3,
              8,
              12
            ],
            "weight_min": 2,
            "weight_max": 15
          }
        }
      }
    ]
  },
  {
    "serialNumber": 35,
    "fishId": "chaka",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              17,
              41,
              60
            ],
            "weight_min": 6,
            "weight_max": 71
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "portion": {
            "weights": [
              13,
              29,
              43
            ],
            "weight_min": 5,
            "weight_max": 51
          }
        }
      }
    ]
  },
  {
    "serialNumber": 36,
    "fishId": "chali",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              19,
              38,
              73
            ],
            "weight_min": 5,
            "weight_max": 87
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "portion": {
            "weights": [
              10,
              27,
              53
            ],
            "weight_min": 2,
            "weight_max": 64
          }
        }
      }
    ]
  },
  {
    "serialNumber": 37,
    "fishId": "goda",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              16,
              38,
              66
            ],
            "weight_min": 3,
            "weight_max": 79
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "portion": {
            "weights": [
              12,
              30,
              45
            ],
            "weight_min": 3,
            "weight_max": 54
          }
        }
      }
    ]
  },
  {
    "serialNumber": 38,
    "fishId": "prawn",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              10,
              15,
              22
            ],
            "weight_min": 7,
            "weight_max": 25
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              9,
              18,
              24
            ],
            "weight_min": 5,
            "weight_max": 28
          }
        }
      }
    ]
  },
  {
    "serialNumber": 39,
    "fishId": "horina",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              15,
              32,
              60
            ],
            "weight_min": 3,
            "weight_max": 72
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "portion": {
            "weights": [
              12,
              23,
              46
            ],
            "weight_min": 3,
            "weight_max": 55
          }
        }
      }
    ]
  },
  {
    "serialNumber": 40,
    "fishId": "kakra",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "whole": {
            "weights": [
              11,
              16,
              20
            ],
            "weight_min": 8,
            "weight_max": 23
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "whole": {
            "weights": [
              8,
              16
            ],
            "weight_min": 6,
            "weight_max": 18
          }
        }
      }
    ]
  },
  {
    "serialNumber": 41,
    "fishId": "rosna",
    "recipes": [
      {
        "recipe": "curry",
        "portionTypes": {
          "portion": {
            "weights": [
              13,
              37,
              64
            ],
            "weight_min": 2,
            "weight_max": 77
          }
        }
      },
      {
        "recipe": "fry",
        "portionTypes": {
          "portion": {
            "weights": [
              12,
              26,
              41
            ],
            "weight_min": 4,
            "weight_max": 49
          }
        }
      }
    ]
  },
  {
    "serialNumber": 42,
    "fishId": "shrimp",
    "recipes": [
      {
        "recipe": "fry",
        "portionTypes": {
          "portion": {
            "weights": [
              17,
              35,
              57
            ],
            "weight_min": 7,
            "weight_max": 67
          }
        }
      }
    ]
  }
];
